import { SOCIAL_BAR_ACTION_TYPES, } from '../socialBarActionTypes';
import { setUserVote, getClientVotes, } from '../socialBarDataSource';
import { getPostVotes, } from './socialBarDataMock';
export function sendVote({ postId, reactionId, }){
  return (dispatch, getState) => {
    setUserVote({ postId, reactionId, });
    dispatch({
      type: SOCIAL_BAR_ACTION_TYPES.REACTIONS.SEND_VOTE,
      state: {
        selectedReaction: reactionId,
      }
    });
  };
}
// todo: move elsewhere
function mergeVotes({ myVotes, otherVotes, postId, }){
  if (!(postId in myVotes)) {
    return otherVotes;
  }
  const myReaction = myVotes[postId];
  const votesWithMe = { [myReaction]: (otherVotes[myReaction] || 0) + 1 };
  const ret = { ...otherVotes, ...votesWithMe, };
  return ret;
}
export function getVotes({ postId, }){
  return (dispatch, getState) => {
    const otherVotes = getPostVotes();
    const myVotes = getClientVotes();
    const merged = mergeVotes({ myVotes, otherVotes, postId });
    dispatch({
      type: SOCIAL_BAR_ACTION_TYPES.REACTIONS.GET_VOTES,
      state: {
        votes: merged,
      }
    });
  };
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/mock/socialBarActionsMock.js